import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { RangeSliderElementDirective } from '@df/ui/form/range-slider/range-slider-element.directive';
import { ValueHelper } from '@df/ui/form/range-slider/value-helper';

@Directive({
    selector: '[rangeSliderLabel]',
    standalone: false
})
export class RangeSliderLabelDirective extends RangeSliderElementDirective {
    private _value?: string;
    get value(): string {
        return this._value!;
    }

    constructor(elemRef: ElementRef, renderer: Renderer2) {
        super(elemRef, renderer);
    }

    setValue(value: string): void {
        let recalculateDimension = false;
        if (
            !this.alwaysHide &&
            (ValueHelper.isNullOrUndefined(this.value) ||
                this.value.length !== value.length ||
                (this.value.length > 0 && this.dimension === 0))
        ) {
            recalculateDimension = true;
        }

        this._value = value;
        this.elemRef.nativeElement.innerHTML = value;

        // Update dimension only when length of the label have changed
        if (recalculateDimension) {
            this.calculateDimension();
        }
    }
}
